import { render, staticRenderFns } from "./AddBankModal.vue?vue&type=template&id=6d32c1e7&"
import script from "./AddBankModal.vue?vue&type=script&lang=js&"
export * from "./AddBankModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports